package us.laantech.routes.users

import kotlinx.serialization.Serializable
import us.laantech.common.dto.UserGroups

// Closely match AdminGetUserResponse

/**
 * Data Transfer Object for User.
 * User data model with fields for authentication and authorization.
 */
@Serializable
data class UserDTO(
    // Common between AWS and API
    val username: String? = null,
    val enabled: Boolean? = null,
    val email: String? = null,

    val phoneNumber: String? = null,

    val updatedAt: Long? = null,

    val sub: String? = null, // The JWT Subject

    // API only
    val displayName: String? = null,


    /**
     * Password Requirements:
     * - At least 10 characters
     * - At least 1 uppercase letter
     * - At least 1 lowercase letter
     * - At least 1 digit
     * */
//    @field:Schema(pattern = "^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d).{10,99}\$\n")
    val password: String? = null,

//    @field:Schema(pattern = "^\\+[1-9]\\d{1,14}\$\n")
    val phoneNumberMobile: String? = null,

//    @field:Schema(pattern = "^(INTERNAL|EXTERNAL|BUSINESS|CONSUMER)$")
    val group: UserGroups? = null,
    val roles: Set<String>? = null,

    val createdAt: Long? = null,



    ) {

    init {
        sub?.let {
            val ID_REGEX = Regex("^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$")
            require(ID_REGEX.matches(it)) { "Invalid sub format" }
        }

        username?.let { require(it.length <= 255) { "Username too long" } }

        email?.let {
            val EMAIL_REGEX = Regex("^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$")
            require(EMAIL_REGEX.matches(it)) { "Invalid email format" }
        }
    }
}